export enum Font {    
    Default = "Maven Pro",
    Advanced = "Domine",
    Poppins = "Poppins"
}